module.exports = function getResource(label, vars = []) {
    const resources = {
        updatedLabel: 'MIS À JOUR',
        applyText: 'Appliquer',
        appliedText: 'Appliqué',
        addedText: 'Ajouté',
        removeText: 'Supprimer',
        viewPromoCodesText: 'Voir les offres en vedette',
        ccPromoLabel: 'Code promotionnel ou de récompense',
        promoLabel: 'Code promo',
        gotIt: 'OK',
        youCanAddPromos: 'Certaines promotions ne s’appliquent pas aux commandes à ramasser. Vous pouvez ajouter des récompenses en magasin, s’il y a lieu.'
    };

    return resources[label];
};
